import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../constants';

export function useApplicationTracking(token) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    if (!token) {
      setError('Hakemustunnus puuttuu.');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${API_URL}api/public/applications/${encodeURIComponent(token)}`
      );
      setData(response.data);
    } catch (err) {
      console.error(err);
      setData(null);
      setError('Hakemusta ei löytynyt. Tarkista hakemustunnus.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { data, loading, error, refetch: fetchStatus };
}
